import { FC } from 'react'
import styles from './free-mail-offer-card.module.scss'
import { useTranslation } from 'react-i18next'
import OfferCard from '../OfferCard'

type FreeMailOfferCardProps = {}

const FreeMailOfferCard: FC<FreeMailOfferCardProps> = ({}) => {
  const { t } = useTranslation()

  return (
    <OfferCard
      title={t('free_domain_mail')}
      button={{ text: t('more-details'), href: '/service/mail' }}
      bgClassName={styles.bg}
      bgSrc={'/img/bg/features-domains-3.svg'}
    >
      {t('free_domain_mail_desc')}
    </OfferCard>
  )
}

export default FreeMailOfferCard
